module.exports = "/_next/static/images/water-small-c074d9b0174b3688475e898fbb76f367.webp";